export const NOTIFICATION_TEMPLATES_KEYS: any = {
  titlePrefix: {
    1: 'metric_id_1_title_prefix',
    2: 'metric_id_2_title_prefix',
    3: 'metric_id_3_title_prefix',
    21: 'metric_id_21_title_prefix',
    22: 'metric_id_22_title_prefix',
    23: 'metric_id_23_title_prefix',
    32: 'metric_id_32_title_prefix',
    33: 'metric_id_33_title_prefix',
    42: 'metric_id_42_title_prefix',
    43: 'metric_id_43_title_prefix',
    51: 'metric_id_51_title_prefix',
    52: 'metric_id_52_title_prefix',
    53: 'metric_id_53_title_prefix',
  },
  titles: {
    1: 'metric_id_1_title_topic',
    2: 'metric_id_2_title_topic',
    3: 'metric_id_3_title_topic',
    21: 'metric_id_21_title_topic',
    22: 'metric_id_22_title_topic',
    23: 'metric_id_23_title_topic',
    32: 'metric_id_32_title_topic',
    33: 'metric_id_33_title_topic',
    42: 'metric_id_42_title_topic',
    43: 'metric_id_43_title_topic',
    51: 'metric_id_51_title_topic',
    52: 'metric_id_52_title_topic',
    53: 'metric_id_53_title_topic',
  },
  descriptions: {
    1: 'metric_acceptance_rate_description',
    2: 'metric_acceptance_rate_description',
    3: 'metric_acceptance_rate_description',
    21: 'metric_orders_recovered_description',
    22: 'metric_orders_recovered_description',
    23: 'metric_orders_recovered_description',
    32: 'metric_orders_rejected_description',
    33: 'metric_orders_rejected_description',
    42: 'metric_gmv_lift_description',
    43: 'metric_gmv_lift_description',
    51: 'metric_error_code_description',
    52: 'metric_error_code_description',
    53: 'metric_error_code_description',
  },
  increaseText: {
    aumentado: 'description_increase_text_increased',
    disminuido: 'description_increase_text_decreased',
  },
  increaseTextErrorCategory: {
    aumentado: 'description_increase_text_increased_error_category',
    disminuido: 'description_increase_text_decreased_error_category',
  },
  frequencyDesc: {
    daily: 'description_notification_frequency_desc_daily',
    weekly: 'description_notification_frequency_desc_weekly',
    monthly: 'description_notification_frequency_desc_monthly',
  },
  defaults: {
    title: 'default_metric_title',
    description: 'default_metric_description',
  },
};

export const NOTIFICATION_ICON_MAP: any = {
  behavior: 'mdi:update',
  performance: {
    aumentado: 'mdi:trending-up',
    disminuido: 'mdi:trending-down',
  },
};

export const NOTIFICATION_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';

export const ERROR_CATEGORY_METRIC_IDS = [51, 52, 53];

export const BEHAVIOR = {
  prefix: {
    connectProvider: 'updated',
    editProvider: 'updated',
    disableProvider: 'updated',
    enableProvider: 'updated',
    updateFraud: 'updated',
    editDefaultRule: 'updated',
    createRule: 'updated',
    disableRule: 'updated',
    enableRule: 'updated',
  },
  topic: {
    connectProvider: 'connection',
    editProvider: 'connection',
    disableProvider: 'connection',
    enableProvider: 'connection',
    updateFraud: 'connection',
    editDefaultRule: 'strategyRules',
    createRule: 'strategyRules',
    disableRule: 'strategyRules',
    enableRule: 'strategyRules',
  },
};

export const BEHAVIOR_TYPE = 'behavior';
